<template>
  <div id="top">
    <div v-show="isTwoLabel" class="twoLabelContainer">
      <div class="breadcrumb">
        <span class="breadcrumbText">当前位置：首页 > </span><a class="hoverClass" @click="backHandle">{{ firstLabelName }}</a>
      </div>
      <div class="twoLabel">
        <a-collapse
          :bordered="false"
          v-model="activeKey"
          style="background-color:white;"
          v-for="(label, labelIndex) in twoLabelList"
          :key="label.labelId"
        >
          <a-collapse-panel :key="labelIndex+''" :showArrow="false" :disabled="!(label.children && label.children.length > 0)">
            <template #header="props">
              <div style="display: flex;align-items: center;" :style="props.isActive ? '' : 'margin-bottom: 4px;'" :id="label.labelId">
                <a-icon :component="allowLowerRight" style="margin-right: 16px;" :style="{ fontSize: '8px'}" />
                <a class="twoLabelName" @click.stop="jumpMatterList(label.labelId, label.labelName)">{{ labelIndex + 1 }}、{{ label.labelName }}</a>
                <span class="downUp" v-if="label.children && label.children.length > 0">
                  {{ label.children.length }}项
                  <a-icon v-show="props.isActive" type="down" style="margin-left: 10px;" />
                  <a-icon type="up" v-show="!props.isActive" style="margin-left: 10px;"/>
                </span>
              </div>
            </template>
            <div v-for="(item, index) in label.children" :key="item.labelId">
              <div>
                <div class="thirdLabel" @click.stop="jumpMatterList(item.labelId, item.labelName)" :id="item.labelId">
                  {{ labelIndex+1 }}.{{ index+1 }}、{{ item.labelName }}
                </div>
                <template v-for="(matter, matterIndex) in item.relatedItemList">
                  <div @click="toOneThingGuide(matter.iid, matter.itemName, matter)" :key="matter.iid" class="matterName" :style="matterIndex.length === (matterIndex + 1) ? 'margin-bottom: 0px;' : 'margin-bottom: 12px;'">
                    <a>{{ matter.itemName }}</a>
                  </div>
                </template>
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
      <div style="text-align:center;margin: 30px;">
        <a-pagination
          size="small"
          :total="totalCount"
          v-model="params.pageNo"
          @change="pageChange"
          show-quick-jumper
          :show-total="total => `共有 ${total} 条`"
          v-show="totalCount > 10"
        />
      </div>
    </div>
    <MatterList ref="matterList" v-show="!isTwoLabel" @backLabel="backLabel" @backFirstHandle="backFirstHandle"></MatterList>
  </div>
</template>

<script>
import allowLowerRight from '../arrow_lowerRight.svg?inline'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb.js'
import MatterList from '@/views/jiopweb/singleEventList/components/MatterList.vue'
export default {
  name: 'TwoLevelLabel',
  components: {
    MatterList
  },
  data () {
    return {
      allowLowerRight,
      activeKey: ['0'],
      twoLabelList: [],
      firstLabelName: '',
      totalCount: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
        districtId: sessionStorage.getItem('districtId'),
        labelId: ''
      },
      isTwoLabel: true
    }
  },
  methods: {
    init (labelId, name) {
      if (labelId) {
        this.firstLabelName = name
        this.params.labelId = labelId
      }
      jiopWebAPI.findChildList(this.params).then(res => {
        this.twoLabelList = res.data.list.outParams.list.filter((v, index) => {
          return (this.params.pageNo - 1) * 10 <= index && index < 10 * this.params.pageNo
        })
        this.totalCount = res.data.list.totalCount
        // 展开第一个存在子项的数据
        try {
          this.twoLabelList.forEach((v, index) => {
            if (v.children && v.children.length > 0) {
              this.activeKey = [index]
              throw new Error(index)
            }
          })
        } catch (error) {
        }
      })
    },
    backHandle () {
      this.params.pageNo = 1
      this.$emit('backHandle', this.params.labelId)
    },
    jumpMatterList (labelId, labelName) {
      this.scrollTop()
      this.$refs.matterList.init(labelId, { firstLabelName: this.firstLabelName, labelName: labelName })
      this.isTwoLabel = false
    },
    backLabel (id) {
      this.isTwoLabel = true
      setTimeout(() => {
        document.getElementById(`${id}`).scrollIntoView({
          behavior: 'smooth', // 平滑过渡
          block: 'start' // 上边框与视窗顶部平齐
        })
      }, 500)
    },
    // 返回第一层标签
    backFirstHandle () {
      this.isTwoLabel = true
      this.backHandle()
    },
    pageChange (pageNo) {
      this.params.pageNo = pageNo
      this.init()
    },
    toOneThingGuide (value, name, itt) {
      sessionStorage.setItem('matter_name', itt.oneThingName)
      const url = this.$router.resolve({ path: '/guideSimple', query: { itemId: value, bannerType: this.$route.query.bannerType } })
      window.open(url.href, '_blank')
    },
    scrollTop () {
      setTimeout(() => {
        document.getElementById('top').scrollIntoView({
          behavior: 'smooth', // 平滑过渡
          block: 'start' // 上边框与视窗顶部平齐
        })
      }, 0)
    }
  }
}
</script>

<style scoped lang="less">
.hoverClass {
  color: rgba(89, 89, 89, 1);
}
.hoverClass:hover {
  color: #1677FF;
}
a {
  color: #1677FF;
}
.twoLabelContainer {
  width: 1300px;
  margin: auto;
  min-height: 480px;
  padding-left: 50px;
  padding-top: 20px;
}
.breadcrumb {
  padding-bottom: 14px;
  .breadcrumbText {

    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
  }
}
/deep/.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding: 16px 0 12px 0 ;
}
/deep/.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
  padding-bottom: 0px;
}
.twoLabelName {

  font-size: 16px;
  color: #333333;
  font-weight: 400;
  height: 28px;
  line-height: 28px;
}
.downUp{
  display: inline-block;
  width: 70px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: rgba(241, 242, 243, 1);
  margin-left: 12px;
}
.thirdLabel {

  font-size: 14px;
  color: #555555;
  line-height: 28px;
  font-weight: 400;
  margin-left: 32px;
  margin-bottom: 12px;
}
.matterName {

  font-size: 14px;
  color: #1677FF;
  line-height: 28px;
  font-weight: 400;
  margin-left: 70px;
  margin-top: 12px;
}
</style>
